// extracted by mini-css-extract-plugin
export default {"banner":"UserVerificationBanner__banner--3MQ","icon":"UserVerificationBanner__icon--3aI","text":"UserVerificationBanner__text--2pi","link":"UserVerificationBanner__link--2Lq"};